import { useEffect, useState } from 'react'

import { Heading } from '@nx/fire/typography'
import { calculateTimeLeft, formatNumberIn2Digits } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import {
  StyledContainer,
  StyledTimeContainer,
  StyledTimeFragment,
  StyledTimeTitle,
  StyledTitle,
} from './FlipClockTimer.styles'
import translate from './FlipClockTimer.translate.json'

const { text } = getTranslate(translate)

export function FlipClockTimer({ endDate }: FlipClockTimerProps) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endDate))

  useEffect(() => {
    const interval = setInterval(
      () => setTimeLeft(calculateTimeLeft(endDate)),
      1000
    )
    return () => {
      clearInterval(interval)
    }
  }, [endDate])

  return (
    <StyledContainer>
      <StyledTitle $level="M">{text('lotClosesIn')}</StyledTitle>
      <StyledTimeContainer>
        <StyledTimeFragment $isMinWidth>
          <Heading $level={4} as="div" suppressHydrationWarning>
            {formatNumberIn2Digits(timeLeft.days)}
          </Heading>
          <StyledTimeTitle $level="XS" as="span">
            {text('days')}
          </StyledTimeTitle>
        </StyledTimeFragment>
        <StyledTimeFragment>
          <Heading $level={4} as="div" suppressHydrationWarning>
            {formatNumberIn2Digits(timeLeft.hours)}
          </Heading>
          <StyledTimeTitle $level="XS" as="span">
            {text('hours')}
          </StyledTimeTitle>
        </StyledTimeFragment>
        <StyledTimeFragment>
          <Heading $level={4} as="div" suppressHydrationWarning>
            {formatNumberIn2Digits(timeLeft.minutes)}
          </Heading>
          <StyledTimeTitle $level="XS" as="span">
            {text('mins')}
          </StyledTimeTitle>
        </StyledTimeFragment>
        <StyledTimeFragment>
          <Heading $level={4} as="div" suppressHydrationWarning>
            {formatNumberIn2Digits(timeLeft.seconds)}
          </Heading>
          <StyledTimeTitle $level="XS" as="span">
            {text('secs')}
          </StyledTimeTitle>
        </StyledTimeFragment>
      </StyledTimeContainer>
    </StyledContainer>
  )
}

export interface FlipClockTimerProps {
  endDate: Date
}
